<template>
    <div></div>
</template>

<script>
    import { getUserInfo, getAuthorizeUrl } from "../api.js";
    export default {
        data() {
            return {};
        },
        activated() {
            let code = this.$route.query.code;
            if (code) {
                //授权回调，获取openid
                getUserInfo({
                    code: code,
                }).then((res) => {
                    if (res.data.Code != 0) {
                        this.$message({
                            message: res.data.Message,
                            type: "warning",
                        });
                        return;
                    }
                    let openid = res.data.Data.openid;
                    localStorage.setItem("openid", openid);
                    //页面跳转
                    let state = this.$route.query.state;
                    console.log(state);
                    switch (state) {
                        case "Login":
                            this.$router.replace("/login");
                            break;
                        default:
                            this.$router.replace("/login");
                            break;
                    }
                });
            } else {
                //请求微信授权
                getAuthorizeUrl({
                    url: location.href,
                    state: this.$route.query.state,
                }).then((res) => {
                    if (res.data.Code != 0) {
                        this.$message({
                            message: res.data.Message,
                            type: "warning",
                        });
                        return;
                    }
                    location.href = res.data.Data;
                });
            }
        },
        methods: {},
    };
</script>

<style>
</style>